import { toString } from 'lodash'

import { PAGINATION } from '../../../../common/constants'

const userSettingsFormInitialValues = values => ({
  ...values,
  pageSize: toString(values.pageSize || PAGINATION.DEFAULT_PAGE_SIZE),
})

export default userSettingsFormInitialValues
